import { Routes } from "@angular/router";
import { GuestPaymentComponent } from "@app/pages/guestpayment/guestpayment/guestpayment.component";
import { GuestPaymentRedirect } from "@app/pages/guestpayment/guestpaymentredirect/guestPaymentRedirect.component";
import { GuestPaymentClear } from "@app/pages/guestpayment/guestpaymentclear/guestpaymentclear";
import { GuestPaymentCancelComponent } from "@app/pages/guestpayment/guestpaymentcancel/guestPaymentCancel.component";
import { GuestPaymentCheckComponent } from "@app/pages/guestpayment/guestpaymentcheck/guestPaymentCheck.component";
import { GuestPaymentCardComponent } from "@app/pages/guestpayment/guestpaymentcard/guestPaymentCard.component";
import { GuestPaymentConfirmationComponent } from "@app/pages/guestpayment/guestpaymentconfirmation/guestpaymentconfirmation.component";
import { GuestPaymentSuccessComponent } from "@app/pages/guestpayment/guestpaymentsuccess/guestPaymentSuccess.component";
import { GuestAmenitiesPaymentSelectAmenitiesComponent } from "@app/pages/guestpayment/guestAmenitiesPaymentSelectAmenities/guestAmenitiesPaymentSelectAmenities.component";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { LoginComponent } from "@app/pages/welcome/login/login.component";
import { PayByMailComponent } from "@app/pages/welcome/paybymail/payByMail.component";
import { SignupComponent } from "@app/pages/welcome/signup/signup.component";
import { RegistrationComponent } from "@app/pages/registration/registration.component";
import { RegistrationEasyComponent } from "@app/pages/registration/easy/registrationEasy.component";
import { RegistrationStep2Component } from "@app/pages/registration/registrationStep2.component";
import { CreateAccountComponent } from "@app/pages/registration/createAccount.component";
import { CallbackComponent } from "@app/pages/callback/callback.component";
import { StartSsoLoginComponent } from "@app/sso/start-sso-login/start-sso-login.component";
import { MakeSsoDecisionComponent } from "@app/sso/make-sso-decision/make-sso-decision.component";
import { CreateSsoProfileComponent } from "@app/sso/create-sso-profile/create-sso-profile.component";
import { SearchSsoProfileComponent } from "@app/sso/search-sso-profile/search-sso-profile.component";
import { ExistingSsoProfileMergeComponent } from "@app/sso/existing-sso-profile-merge/existing-sso-profile-merge.component";
import { ssoIdentityGuard } from "@app/guards/sso-identity/sso-identity.guard";

/**
 * @description used for consistent Google Analytics `page_title`s
 * https://developers.google.com/analytics/devguides/collection/gtagjs/pages
 */
export function pageTitle(domain: 'Guest' | 'Registered', section: string, purpose?: string): string {
    return domain + ' / ' + section + (purpose ? `: ${purpose}` : '')
}

export const GuestRoutes: Routes = [
    {
        path: "",
        component: LoginComponent,
        title: pageTitle("Registered", "Welcome"),
        data: { section: "welcome", hideHeader: true, hideFooter: true },
    },

    {
        path: "welcome",
        component: LoginComponent,
        title: pageTitle("Registered", "Welcome"),
        data: { section: "welcome", hideHeader: true, hideFooter: true },
    },

    {
        path: "callback",
        component: CallbackComponent,
        title: pageTitle("Guest", "Callback"),
        data: { section: "callback", hideHeader: true, hideFooter: true },
    },

    {
        path: "paybymail",
        component: PayByMailComponent,
        title: pageTitle("Registered", "Pay by Mail"),
        data: { section: "paybymail", hideHeader: true, hideFooter: true },
    },

    {
        path: "signup",
        component: SignupComponent,
        title: pageTitle("Registered", "Signup"),
        data: { section: "signup", hideFooter: true },
    },

    {
        path: "register",
        component: RegistrationComponent,
        title: pageTitle("Registered", "Register", "Step 1 - Personal Info"),
        data: { section: "register", hideFooter: true },
    },

    {
        path: "registerEasy",
        component: RegistrationEasyComponent,
        title: pageTitle("Guest", "Register"),
        data: { section: "registerEasy", hideFooter: true, isGuest: true },
    },

    {
        path: "registerStep2",
        component: RegistrationStep2Component,
        title: pageTitle("Registered", "Register", "Step 2 - Confirm Property"),
        data: { section: "registerStep2", hideFooter: true },
    },

    {
        path: "createAccount",
        component: CreateAccountComponent,
        title: pageTitle("Registered", "Register", "Step 3 - Create Account"),
        data: { section: "createAccount", hideFooter: true },
    },

    {
        path: "guestpayment",
        component: GuestPaymentComponent,
        title: pageTitle("Guest", "Payment", "Confirm Property"),
        data: { section: "guestpayment", hideFooter: true, isGuest: true },
    },

    {
        path: "guestpayment/redirect",
        component: GuestPaymentRedirect,
        title: pageTitle("Guest", "Payment", "Redirect"),
        data: {
            section: "guestpaymentredirect",
            hideFooter: true,
            isGuest: true,
        },
    },

    {
        path: "guestpayment/clear",
        component: GuestPaymentClear,
        title: pageTitle("Guest", "Payment", "Clear Payment"),
        data: { section: "guestPaymentClear", isGuest: true },
    },

    {
        path: "guestPaymentCancel",
        component: GuestPaymentCancelComponent,
        title: pageTitle("Guest", "Payment", "Cancel Payment"),
        data: {
            section: "guestPaymentCancel",
            hideFooter: true,
            isGuest: true,
        },
    },

    {
        path: "guestpaymentecheck",
        component: GuestPaymentCheckComponent,
        title: pageTitle("Guest", "Payment", "Pay by eCheck"),
        data: { section: "guestPaymentCheck", hideFooter: true, isGuest: true },
    },

    {
        path: "guestpaymentcard",
        component: GuestPaymentCardComponent,
        title: pageTitle("Guest", "Payment", "Pay by Card"),
        data: { section: "guestPaymentCard", hideFooter: true, isGuest: true },
    },

    {
        path: "guestPaymentConfirmation",
        component: GuestPaymentConfirmationComponent,
        title: pageTitle("Guest", "Payment", "Confirm Payment"),
        data: {
            section: "guestPaymentConfirmation",
            hideFooter: true,
            isGuest: true,
        },
    },

    {
        path: "guestPaymentSuccess",
        component: GuestPaymentSuccessComponent,
        title: pageTitle("Guest", "Payment", "Payment Accepted"),
        data: {
            section: "guestPaymentSuccess",
            hideFooter: true,
            isGuest: true,
        },
    },

    {
        path: "amenities",
        children: [
            {
                path: "guestpayment",
                component: GuestPaymentComponent,
                title: pageTitle(
                    "Guest",
                    "Amenities Payment",
                    "Confirm Property"
                ),
                data: {
                    section: "guestAmenitiesPayment",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestpayment/redirect",
                component: GuestPaymentRedirect,
                title: pageTitle("Guest", "Amenities Payment", "Redirect"),
                data: {
                    section: "guestAmenitiesPaymentRedirect",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestPaymentCancel",
                component: GuestPaymentCancelComponent,
                title: pageTitle("Guest", "Payment", "Cancel Payment"),
                data: {
                    section: "guestAmenitiesPaymentCancel",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestpaymentecheck",
                component: GuestPaymentCheckComponent,
                title: pageTitle("Guest", "Amenities Payment", "Pay by eCheck"),
                data: {
                    section: "guestAmenitiesPaymentCheck",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestpaymentcard",
                component: GuestPaymentCardComponent,
                title: pageTitle("Guest", "Amenities Payment", "Pay by Card"),
                data: {
                    section: "guestAmenitiesPaymentCard",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestPaymentConfirmation",
                component: GuestPaymentConfirmationComponent,
                title: pageTitle("Guest", "Payment", "Confirm Payment"),
                data: {
                    section: "guestAmenitiesPaymentConfirmation",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "guestPaymentSuccess",
                component: GuestPaymentSuccessComponent,
                title: pageTitle("Guest", "Payment", "Payment Accepted"),
                data: {
                    section: "guestAmenitiesPaymentSuccess",
                    hideFooter: true,
                    isGuest: true,
                    paymentEntityType: PaymentEntityType.AMENITY,
                },
            },

            {
                path: "select",
                component: GuestAmenitiesPaymentSelectAmenitiesComponent,
                title: pageTitle(
                    "Guest",
                    "Amenities Payment",
                    "Select Amenities"
                ),
                data: {
                    section: "guestAmenitiesPaymentSelectAmenities",
                    hideFooter: true,
                    isGuest: true,
                },
            },
        ],
    },

    {
        path: "sso",
        children: [
            {
                path: "",
                component: StartSsoLoginComponent,
                title: pageTitle("Guest", "Sso", ""),
                data: {
                    section: "sso.loginStart",
                    hideHeader: true,
                    hideFooter: true,
                },
            },

            {
                path: "make-decision",
                component: MakeSsoDecisionComponent,
                canActivate: [ssoIdentityGuard],
                title: pageTitle("Guest", "Sso", ""),
                data: {
                    section: "sso.decision",
                    hideHeader: false,
                    hideFooter: false,
                },
            },

            {
                path: "create-profile",
                component: CreateSsoProfileComponent,
                canActivate: [ssoIdentityGuard],
                title: pageTitle("Guest", "Sso", ""),
                data: {
                    section: "sso.createProfile",
                    hideHeader: false,
                    hideFooter: false,
                },
            },

            {
                path: "search-profile",
                component: SearchSsoProfileComponent,
                canActivate: [ssoIdentityGuard],
                title: pageTitle("Guest", "Sso", ""),
                data: {
                    section: "sso.searchProfile",
                    hideHeader: false,
                    hideFooter: false,
                },
            },

            {
                path: "merge-profile",
                component: ExistingSsoProfileMergeComponent,
                canActivate: [ssoIdentityGuard],
                title: pageTitle("Guest", "Sso", ""),
                data: {
                    section: "sso.mergeProfile",
                    hideHeader: false,
                    hideFooter: false,
                },
            },
        ],
    },

    {
        matcher: url => {
            if (url.length > 1 && url[url.length - 2].path.match("redirect")) {
                return {
                    consumed: url,
                };
            }
            return null;
        },
        redirectTo: window.location.hash
            .substring(1)
            .replace("redirect/", "redirect?"),
    },
];
